import clsx from 'clsx'
import i18n from 'src/i18n'
import { NO_IMAGE } from 'src/assets/svg'
import { filterPermission } from 'src/utils/user'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { PERMISSIONS_ACTIONS } from 'src/utils/user/constant'
import { PermissionActions } from 'src/services/posts'

import { LiveStatus } from '../../types'
import { LiveBadge } from '../liveBadge'
import { LiveHeader } from '../liveHeader'
import { H2, Div, P, Picture, LiveHighLightContainer } from './liveHighlight.styles'
import { LiveHighlightProps } from './liveHighlight.types'

const LiveHighlight = ({
  liveDetail,
  className,
  isHighlight = false,
  permissions
}: LiveHighlightProps) => {
  const { community } = useCommunityDetails()

  const canStartLive = [
    filterPermission({
      specificPermission: PERMISSIONS_ACTIONS.WEBINAR_CREATE,
      permissionsUserList: community.permissions?.actions as PermissionActions[]
    }),
    filterPermission({
      specificPermission: PERMISSIONS_ACTIONS.WEBINAR_CREATE,
      permissionsUserList: permissions?.actions as PermissionActions[]
    })
  ].some((result) => result === true)

  const isLiveCompleted = liveDetail?.status === LiveStatus.COMPLETED

  const shouldHideButton = !liveDetail?.enableVodPlayback && isLiveCompleted

  const btnLabel =
    liveDetail?.enableVodPlayback && isLiveCompleted
      ? 'live.highlight.button_watch_vod'
      : 'live.highlight.button'

  const handleClick = () => {
    if (!liveDetail?.link) return

    let link = liveDetail.link

    if (canStartLive && !isLiveCompleted && liveDetail.managementLink) {
      link = liveDetail.managementLink
    }

    window.open(link, '_blank')?.focus()
  }

  return (
    <LiveHighLightContainer
      className={clsx('_d-flex _rounded-lg _border _overflow-hidden _mb-4', className)}
    >
      <Div className="_py-4 _px-5 _d-flex _flex-column _justify-content-center">
        <LiveHeader isHighlight={isHighlight} liveDetail={liveDetail} />
        <H2 className="_mb-2">{liveDetail?.title}</H2>
        {liveDetail?.description ? (
          <P className="_mb-3 _font-14">{liveDetail?.description}</P>
        ) : null}
        {shouldHideButton ? null : (
          <button onClick={handleClick} className="hot-button hot-button--primary">
            {i18n.t(btnLabel)}
          </button>
        )}
      </Div>
      <Picture className="_d-flex _justify-content-center _position-relative">
        <img src={liveDetail?.thumbnail ?? NO_IMAGE} alt={liveDetail?.title} loading="lazy" />
        <LiveBadge />
      </Picture>
    </LiveHighLightContainer>
  )
}

export default LiveHighlight
